import styled from 'styled-components';
import { mediaQueries } from '../../../../utils/styles';

const RawButon = styled.button`
  cursor: pointer;
  border: none;
  margin: 35px 0 25px 0;
  width: 150px;
  height: 38px;
  border-radius: 4px;
  background-image: linear-gradient(to bottom, #2d5696, #1c294b);
  box-shadow: 1px 1px 2px 0 rgba(0, 0, 0, 0.2), 0 5px 4px 0 rgba(0, 0, 0, 0.2);
  color: #fff;
  font-family: 'RobotoThin';
  font-weight: 1000;
  font-size: 15px;
  ${mediaQueries.xs(`
  margin: 15px 0 15px 0;
`)};
`;

export default RawButon;



// WEBPACK FOOTER //
// ./src/views/common/components/Button/styled-components.js